import { Button, Modal } from "antd";
import React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function NoTestAvail() {
  const history = useHistory();
  const [visible, setVisible] = useState(true);
  const handleCancel = () => {
    setVisible(false);
    history.goBack();
  };
  return (
    <Modal
      visible={visible}
      className="sml-modal"
      footer={
        <div className="sml-footer">
          <button className="custom-btn" onClick={handleCancel}>
            OK
          </button>
        </div>
      }
    >
      <h3 style={{ textAlign: "center" }}>
        Test not available at the moment please come back later
      </h3>
    </Modal>
  );
}
